document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const button=document.querySelector('[data-menu-toggle]');
  const nav=document.querySelector('[data-mobile-nav]');
  if(button&&nav){button.addEventListener('click',()=>{const open=nav.classList.toggle('is-open');button.setAttribute('aria-expanded',String(open));});}
  document.querySelectorAll('[data-product-select]').forEach(select=>{
    select.addEventListener('change',()=>{
      const option=select.options[select.selectedIndex];
      const form=select.closest('form');
      const id=form?.querySelector('input[name="id"]');
      if(id) id.value=option.value;
      const price=form?.closest('[data-product-info]')?.querySelector('[data-product-price]');
      if(price&&option.dataset.price) price.textContent=option.dataset.price;
      const button=form?.querySelector('button[type="submit"]');
      if(button){button.disabled=option.disabled;button.textContent=option.disabled?'Sold out':'Add to cart';}
    });
  });
});